import {css} from 'lit-element'; export default css`.analyzer-goto{height:100%;width:100%;position:absolute;left:0;top:0}.goto-text{margin-top:0;margin-left:0;line-height:118%;color:var(--list-text-color,#121212)}`;
    